<template>
  <div class="settings__container">
    <div class="form__main with-preloader">
      <div class="preloader-container"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
      <div class="wraper__main">
        <div class="content">
          <div class="main__about">
            <img class="about__logo" src="../assets/img/new-v.svg" @click="click()">
            <div class="about__description">
              <h2 class="description__title">vcita</h2>
              <div class="description__text">{{ $t("settings.mainHeadingSmallText") }}</div>
            </div>
            <div v-if="premiumFlag == false" class="description__upgrade" v-on:click="upgrade">
              {{ $t("settings.upgradeButton") }}
            </div>
          </div>
        </div>
      </div>
      <div class="tabs__main">
        <tabs ref="tabs">
          <tab class="block__item tab__item_1" :title="$t('tabs.main')">
            <tabMain
              :loggedIn="loggedIn"
              :pivotId="pivot_id"
              :config="paymConfig"
              :userData="userData"
              :instanceId="instanceId"
              @login="connect"
              @inputIndex="changeTab"
              @openUpgradePage="openUpgradePage"
            />
          </tab>
          <tab class="block__item tab__item_2" :title="$t('tabs.settings')">
            <tabSettings
              :loggedIn="loggedIn"
              :pivotId="pivot_id"
              :userData="userData"
              :config="paymConfig"
              :instanceId="wixInstanceId"
              :gatewayConnected="gatewayConnected"
              :paymSyncProcess="paymSyncProcess"
              :showNonLoggedInMsg="pluginConfig.showNonLoggedInMsg"
              :showNonConnectedMsg="pluginConfig.showNonConnectedMsg"
              :showConnectedMsg="pluginConfig.showConnectedMsg"
              @login="connect"
              @changePaym="updatePayments"
              @openUpgradePage="openUpgradePage"
              @syncConfig="syncPaymentConfig" />
          </tab>
          <tab
            class="block__item tab__item_3"
            :title="$t('tabs.design')">
            <tabDesign
              :loggedIn="loggedIn"
              :pivotId="pivot_id"
              :userData="userData"
              :config="pluginConfig"
              :instanceId="wixInstanceId"
              @mounted="nonSettingsTabMounted"
              @openUpgradePage="openUpgradePage"
              @changeDesign="updateDesign" />
          </tab>
          <!--
          <tab class="block__item tab__item_4" :title="$t('tabs.explore')">
            <tabMore :pivotId="pivot_id" :loggedIn="loggedIn" :userData="userData" />
          </tab>
          -->
          <tab class="block__item tab__item_5" :title="$t('tabs.support')">
            <tabSupport
              :loggedIn="loggedIn"
              :pivotId="pivot_id"
              :userData="userData"
              :instanceId="wixInstanceId"
              :checked_rate="pluginConfig.checked_rate"
              @mounted="nonSettingsTabMounted"
              @openUpgradePage="openUpgradePage"
              @changeDesign="updateDesign" />
          </tab>
          <tab
            class="block__item tab__item_6"
            :title="$t('tabs.premium')"
            v-if="premiumFlag == false">
            <tabPremium
              :loggedIn="loggedIn"
              :pivotId="pivot_id"
              :userData="userData"
              :instanceId="wixInstanceId"
              @upgrade="upgrade"
              @mounted="premiumTabMounted" />
          </tab>
        </tabs>
      </div>
      <!--
      <div class="tabs__banner">
        <div class="banner__container">
          <header>{{ $t("banners.bannerHeader") }}</header>
          <ul>
            <li>{{ $t("banners.bannerList_1") }}</li>
            <li>{{ $t("banners.bannerList_2") }}</li>
            <li>{{ $t("banners.bannerList_3") }}</li>
            <li>{{ $t("banners.bannerList_4") }}</li>
            <li>{{ $t("banners.bannerList_5") }}</li>
            <li>{{ $t("banners.bannerList_6") }}</li>
          </ul>
          <footer>
            <a href="#" @click="openUpgradePage">{{ $t("banners.learnMore") }}</a>
          </footer>
        </div>
        <div class="banner2__container">
          <header>{{ $t("banners.banner2Header") }}</header>
          <div class="__mask"></div>
          <div class="__list">
            <ul>
              <li>{{ $t("banners.banner2List_1") }}</li>
              <li>{{ $t("banners.banner2List_2") }}</li>
              <li>{{ $t("banners.banner2List_3") }}</li>
            </ul>
            <ul>
              <li>{{ $t("banners.banner2List_4") }}</li>
              <li>{{ $t("banners.banner2List_5") }}</li>
            </ul>
          </div>
          <footer>
            <a href="#" @click="openUpgradePage">{{ $t("banners.learnMore") }}</a>
          </footer>
        </div>
      </div>
      -->
      <div class="tabs__footer">
        <div class="logged__info" v-if="loggedIn == 1">
          <p>{{ $t("settings.loggedInMessage") }}: <span>{{ userData.email }}</span></p>
          <p class="who__email">
            <a href="#" @click="openDashboard">{{ $t('settings.buttonOpenDashboard') }}</a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="#" @click="disconnect">{{ $t('settings.buttonLogout') }}</a>
          </p>
        </div>
        <div class="logged__info" v-if="loggedIn == 0 && newFunnel">
          <a href="javascript:void(0)" @click="connect(false)">
            {{ $t('settings.alreadyLoggedInMessage') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab } from 'vue-slim-tabs'
import tabMain from '@/components/tab_main.vue'
import tabSettings from '@/components/tab_Settings.vue'
import tabDesign from '@/components/tab_Design.vue'
// import tabMore from '@/components/tab_More.vue'
import tabSupport from '@/components/tab_Support.vue'
import tabPremium from '@/components/tab_Premium.vue'
import * as Helpers from '@/assets/js/helpers.js'
import * as GA from '@/assets/js/ga.js'
import axios from 'axios'

export default {
  name: 'Settings',
  components: {
    Tabs,
    Tab,
    tabMain,
    tabSettings,
    tabDesign,
    // tabMore,
    tabPremium,
    tabSupport
  },
  data: function () {
    const _lm = this.$i18n
    return {
      currentTabName: 'Main',
      loggedIn: 0,
      loggingOut: false,
      fetchingClientData: false,
      paymSyncProcess: false,
      userData: null,
      pivot_id: '',
      instanceId: null,
      gatewayConnected: false,
      alertAvailable: false,
      newFunnel: false,
      premiumFlag: true,
      pluginConfig: {
        ae: 1,
        visa: 1,
        mc: 1,
        paypal: 1,
        dis: 1,
        paypal2: 0,
        buttonText: _lm.t('designTab.buttonPayDefaultText'),
        wixColor: 1,
        checked_rate: '',
        buttonClass: 'default',
        fontFamily: 'Montserrat',
        fontSize: '16',
        textColor: '#384766',
        mainColor: '#ffc43a',
        mainColor2: '#fbbb03',
        borderColor: '#b58c00',
        shadowColor: '#00000080',
        borderSize: 1,
        borderRound: 16,
        showSettingsLabel: 0,
        showNonLoggedInMsg: 1,
        showNonConnectedMsg: 1,
        showConnectedMsg: 1
      },
      paymConfig: {
        paypal_email: '',
        currency: 'USD',
        billing_address: null,
        braintree_merchant_id: null,
        ewallet_type: 'paypal',
        payments_enabled: true,
        payments_gateway_type: 'stripe',
        product_name: '',
        product_price: '',
        square_location_currency: null,
        square_location_id: null,
        square_location_name: null,
        stripe_access_token: null,
        stripe_user_id: null
      },
      preloaderDeleted: false,
      firstLoad: true,
      apiURL: this.$dbapi
    }
  },
  methods: {
    changeTab: function (e) {
      this.$refs.tabs.switchTab(this.$refs.tabs, e)
    },
    checkLoggedIn: function () {
      this.apiGetClientData()
      this.syncPaymentConfig()
    },
    upgrade: function (premiumTab = false) {
      const _this = this
      let closeCheck = function () { _this.syncPlanData() }
      if (this.$TEST_MODE) console.log(this.$instanceData)
      const metaSiteId = localStorage.getItem(`${this.$wixInstanceId}_metasiteId`)
      let url = `https://www.wix.com/apps/upgrade/${this.$instanceData.appDefId}/?metaSiteId=${metaSiteId}`

      GA.track('wix_pay_upgrade', {
        uid: _this.loggedIn ? _this.userData.business_id : null,
        page_action: premiumTab ? 'premium tab' : 'green button'
      })

      Wix.Settings.openModal(url, '100%', '100%', 'vCita pricing', closeCheck) // eslint-disable-line
    },
    openDashboard: function () {
      Wix.Settings.openModal(`//app.${this.$vcitaAddress}/app/dashboard`, '100%', '100%', 'vCita') // eslint-disable-line
    },
    connect: function (e = false) {
      this.newFunnel = false
      const form = document.querySelector('.form__main')
      if (form !== null) form.classList.add('with-preloader')
      if (this.loggedIn === 1) this.disconnect()
      const _this = this
      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        alert('cound not login, wrong instance ID')
        return
      }

      const cd = localStorage.getItem(`vcita_cid_${instanceId}`)

      if (cd === null) {
        alert('cound not login, wrong client ID')
        return
      }

      let url = ''
      let openInNewWin = this.$isSafari
      const rand = true // Math.random() > 0.5
      console.log(_this.$siteInfo)

      if (this.$NEW_AUTH) {
        url = `//app.${this.$vcitaAddress}`
        // let redirect = encodeURIComponent(`/app/oauth/authorize?response_type=code&client_id=${cd}&state=${instanceId}&redirect_uri=${window.location.origin}/callback`)
        if (e) {
          // openInNewWin = rand
          _this.newFunnel = rand
          url += `/app/oauth/authorize?intent=accept_payments_tile&experiment=wix_payments_funnel&registration=true`
          if (_this.$siteInfo) url += `&s=${_this.$siteInfo.baseUrl}`
          // url += `&redirect_to=${redirect}`
        } else {
          url += `/app/oauth/authorize?intent=accept_payments_tile&experiment=wix_payments_funnel`
        }
        url += (rand ? '&experiment_value=new_funnel' : '&experiment_value=original_funnel')
        url += `&invite=WIX-PAYMENTS&response_type=code&client_id=${cd}&state=${instanceId}&redirect_uri=${window.location.origin}/callback`
      } else {
        url = `${this.$vcitaApiURL}/oauth/authorize?response_type=code&client_id=${cd}`
        if (e) {
          url += '&registration=true&experiment=wix_payments_funnel'
          url += (rand ? '&experiment_value=new_funnel' : '&experiment_value=original_funnel')
          if (_this.$siteInfo) url += `&s=${_this.$siteInfo.baseUrl}`
        }
        url += `&redirect_uri=${window.location.origin}/callback`
        url += `&state=${instanceId}&invite=WIX-PAYMENTS`
      }

      let closeCheck = function (o) {
        _this.checkLoggedIn()

        let inte2 = setTimeout(function () {
          localStorage.removeItem(`vc_login_complete_${instanceId}`)
          const form = document.querySelector('.with-preloader')
          if (form !== null) form.classList.remove('with-preloader')

          if (!_this.loggedIn) return
          clearInterval(inte2)

          /*
          if (!this.$TEST_MODE && _this.userData.business_id !== 'xfwg3fv1y72hpztr') {
            _this.premiumFlag = true
          }
          */
          // _this.pluginConfig.showNonLoggedInMsg = 0

          GA.track(e ? 'wixpay_completed_registration' : 'wixpay_completed_signin', {
            uid: _this.userData.business_id
          })
        }, 100)
      }

      if (this.$TEST_MODE) console.log(url)
      let win = null

      const inte = window.setInterval(function () {
        const ud = localStorage.getItem(`vc_usr_data_${instanceId}`)
        const complete = localStorage.getItem(`vc_login_complete_${instanceId}`)

        if (ud !== null) {
          clearInterval(inte)
          // Wix.Settings.closeWindow({ target: 'MODAL' })

          if (!openInNewWin) {
            Wix.Settings.closeWindow({ target: 'MODAL' }) // eslint-disable-line
            // _this.pluginConfig.showNonLoggedInMsg = 0
          } else if (win !== null && !win.closed) {
            win.close()
          }

          GA.track(e ? 'wixpay_completed_registration' : 'wixpay_completed_signin', {
            uid: _this.loggedIn ? _this.userData.business_id : null
          })
        }

        if (complete !== null) {
          localStorage.removeItem(`vc_login_complete_${instanceId}`)
          const form = document.querySelector('.with-preloader')
          if (form !== null) form.classList.remove('with-preloader')
        }
      }, 100)

      // Wix.Settings.openModal(url, '100%', '100%', 'vCita authentication', closeCheck)

      if (!openInNewWin) {
        Wix.Settings.openModal(url, '100%', '100%', 'vCita authentication', closeCheck) // eslint-disable-line
      } else {
        win = window.open(url, '_blank')

        const closeInt = setInterval(() => {
          if (win && win.closed) {
            clearInterval(closeInt)
            closeCheck()
          }
        }, 100)
      }
    },
    disconnect: function () {
      this.premiumFlag = false
      let openInNewWin = this.$isSafari

      GA.track('wixpay_switch_account', {
        uid: this.loggedIn ? this.userData.business_id : null,
        page: this.currentTabName
      })

      localStorage.removeItem(`vc_usr_data_${this.getInstanceId()}`)
      const _this = this
      this.loggingOut = true
      this.loggedIn = 0
      this.userData = null
      delete window.userData

      this.paymConfig = {
        paypal_email: '',
        currency: 'USD',
        billing_address: null,
        braintree_merchant_id: null,
        ewallet_type: 'paypal',
        payments_enabled: true,
        payments_gateway_type: 'stripe',
        product_name: '',
        product_price: '',
        square_location_currency: null,
        square_location_id: null,
        square_location_name: null,
        stripe_access_token: null,
        stripe_user_id: null
      }

      let url
      const instanceId = this.getInstanceId()
      const cd = localStorage.getItem(`vcita_cid_${instanceId}`)
      const useNewAuth = false

      if (cd !== null) {
        if (this.$NEW_AUTH && useNewAuth) {
          url = `www.${this.$vcitaAddress}`
          let redirect = encodeURIComponent(`/app/oauth/authorize?response_type=code&client_id=${cd}&redirect_uri=${window.location.origin}/callback&state=${instanceId}`)
          url += `/logout?intent=accept_payments_tile&redirect_to=${redirect}`
        } else {
          url = `${this.$vcitaApiURL}/oauth/authorize`
          url += `?response_type=code&client_id=${cd}`
          url += `&logout=true&redirect_uri=${window.location.origin}/callback`
          url += `&state=${instanceId}&invite=WIX-PAYMENTS`
        }

        let closeCheck = function (o) { _this.checkLoggedIn() }
        if (this.$TEST_MODE) console.log(url)
        let win

        if (!openInNewWin) {
          Wix.Settings.openModal(url, '100%', '100%', 'vCita authentication', closeCheck) // eslint-disable-line
        } else {
          win = window.open(url, '_blank')
          win.onbeforeunload = closeCheck
        }

        const inte = window.setInterval(function () {
          const ud = localStorage.getItem(`vc_usr_data_${instanceId}`)

          if (ud !== null) {
            clearInterval(inte)
            if (!openInNewWin) {
              Wix.Settings.closeWindow({ target: 'MODAL' }) // eslint-disable-line
              // _this.pluginConfig.showNonLoggedInMsg = 0
            } else if (win && !win.closed) {
              win.close()
            }
          }
        }, 100)
      }

      if (instanceId !== null) {
        url = `${this.apiURL}/logout/${instanceId}`

        axios
          .get(url)
          .then(function (response) {})
          .catch(function (error) { console.log(error) })
          .finally(function () { _this.loggingOut = false })
      } else console.error(`not totally logged out, wrong instanceId ${instanceId}`)

      this.changeTab(0)
    },
    getInstanceId: function () { return this.$wixInstanceId },
    syncPlanData: function () {
      if (this.loggedIn === 0) return

      /*
      if (this.userData.business_id !== 'xfwg3fv1y72hpztr' && !this.$TEST_MODE) {
        // this should work only for hookshot account
        return
      }
      */

      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`plan not fetched, wrong instanceId ${instanceId}`)
        return
      }

      // let planData = Helpers.parseJSON(localStorage.getItem(instanceId + '_plnd'))
      const url = `${this.apiURL}/get_plan/${instanceId}`
      const _this = this

      axios
        .get(url)
        .then(function (response) {
          const d = Helpers.parseJSON(response.data)

          // if (_this.$TEST_MODE) {
          console.log(d)
          // }

          if (d !== null && !d.error) {
            try {
              const integrations = d.data.business.integrations.plugins
              const il = integrations.length
              let plan = {}

              for (let k = 0; k < il; k++) {
                if (integrations[k].external_id === instanceId) {
                  plan = integrations[k]
                  break
                }
              }

              // if (_this.$TEST_MODE || _this.userData.business_id === 'xfwg3fv1y72hpztr') {
              console.log(plan)
              console.log(_this.$instanceData)
              // }

              if (_this.$instanceData) {
                const prodId = _this.$instanceData.vendorProductId
                let wixPlan = typeof prodId === 'string' ? prodId.toLowerCase().trim() : 'free'
                const vcitaPlan = plan.plan_name ? plan.plan_name.toLowerCase().trim() : wixPlan
                let newPlan = null

                if (wixPlan === 'free' && (vcitaPlan === null || vcitaPlan === 'trial' || vcitaPlan.indexOf('free') === 0)) {
                  _this.premiumFlag = false
                }

                if (vcitaPlan !== null && wixPlan !== null && vcitaPlan !== wixPlan) {
                  if (wixPlan === 'free') {
                    if (vcitaPlan === 'free payments' || vcitaPlan === 'online payments' || vcitaPlan === 'essentials') {
                      newPlan = 'trial'
                    }
                  } else if (wixPlan === 'essentials') {
                    if (vcitaPlan === 'trial' || vcitaPlan === 'free payments' || vcitaPlan === 'online payments') {
                      newPlan = 'plugins_ultimate'
                    }
                  } else if (wixPlan === 'invoicing') {
                    if (vcitaPlan === 'free payments' || vcitaPlan === 'essentials' || vcitaPlan === 'online payments' || vcitaPlan === 'trial') {
                      newPlan = 'invoicing'
                    }
                  } else if (wixPlan === 'payments') {
                    if (vcitaPlan === 'free payments' || vcitaPlan === 'essentials' || vcitaPlan === 'online payments' || vcitaPlan === 'trial') {
                      newPlan = 'online_payments'
                    }
                  }
                } else if (vcitaPlan === wixPlan) {
                  if (wixPlan === 'free') {
                    newPlan = 'trial'
                  } else if (wixPlan === 'essentials') {
                    newPlan = 'plugins_ultimate'
                  } else if (wixPlan === 'invoicing') {
                    newPlan = 'invoicing'
                  } else if (wixPlan === 'payments') {
                    newPlan = 'online_payments'
                  }
                }

                if (newPlan === 'trial') _this.premiumFlag = false

                // if (_this.$TEST_MODE || _this.userData.business_id === 'xfwg3fv1y72hpztr') {
                console.log(`vCita plan: ${vcitaPlan}\nWix plan: ${wixPlan}\nTarget plan ID: ${newPlan}`)
                // }
                // if (_this.$TEST_MODE) newPlan = 'free_payments'

                if (newPlan !== null) {
                  axios.get(`${_this.apiURL}/upd_plan/${instanceId}/${newPlan}`)
                    .then((resp1) => {
                      // if (_this.$TEST_MODE || _this.userData.business_id === 'xfwg3fv1y72hpztr') {
                      console.log(resp1.data)
                      // }
                    })
                }
              }
            } catch (e) { console.log(e) }
          } else if (_this.$TEST_MODE) {
            console.log(d)
          }
        }).catch(function (error) { console.log(error) })
    },
    syncPaymentConfig: function () {
      this.paymSyncProcess = true

      if (this.loggedIn === 0) {
        this.paymSyncProcess = false
        return
      }

      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`config not syncronized, wrong instanceId ${instanceId}`)
        this.paymSyncProcess = false
        return
      }

      const url = `${this.apiURL}/sync_cfg/${instanceId}`
      const _this = this

      axios
        .get(url)
        .then(function (response) {
          const d = Helpers.parseJSON(response.data)
          if (_this.$TEST_MODE) console.log(d)

          if (d !== null) {
            for (let i in d) {
              if (i === 'pivot_id') {
                _this.pivot_id = d[i]
                continue
              }

              if (_this.paymConfig[i] !== undefined) {
                if (i === 'square_location_id' && d[i] !== '' && d[i] !== null && d[i] !== _this.paymConfig[i]) {
                  GA.track('wixpay_connected_gateway', {
                    uid: _this.loggedIn ? _this.userData.business_id : null,
                    gateway_type: 'Square'
                  })

                  // _this.removeNotice()
                  _this.gatewayConnected = true
                }

                if (i === 'stripe_user_id' && d[i] !== '' && d[i] !== null && d[i] !== _this.paymConfig[i]) {
                  GA.track('wixpay_connected_gateway', {
                    uid: _this.loggedIn ? _this.userData.business_id : null,
                    gateway_type: 'Stripe'
                  })

                  // _this.removeNotice()
                  _this.gatewayConnected = true
                }

                _this.paymConfig[i] = d[i]
              }

              if (_this.paymConfig.square_location_id !== '' && _this.paymConfig.square_location_id !== null) {
                _this.paymConfig.currency = 'USD'
              }

              localStorage.setItem(`vc_paym_cfg_${instanceId}`, JSON.stringify(_this.paymConfig))
            }
          }
        })
        .catch(function (error) { console.log(error) })
        .finally(function () { _this.paymSyncProcess = false })
    },
    updateDesign: function (o) {
      if (typeof o === 'object' && o !== null) {
        let changed = false

        for (let i in o) {
          if (i === 'ae' || i === 'visa' || i === 'mc' || i === 'paypal' || i === 'dis' || i === 'paypal2' || i === 'wixColor') {
            let val = (o[i] ? 1 : 0)
            if (this.pluginConfig[i] !== val) changed = true
            this.pluginConfig[i] = val
          } else if (i === 'buttonText') {
            let val = o[i].trim()
            if (val.length === 0) val = this.$i18n.t('designTab.buttonPayDefaultText')
            if (this.pluginConfig[i] !== val) changed = true
            this.pluginConfig[i] = val
          } else if (i === 'checked_rate') {
            if (this.pluginConfig[i] !== o[i]) changed = true
            this.pluginConfig[i] = o[i]
          } else if (this.pluginConfig[i] !== undefined) {
            if (this.pluginConfig[i] !== o[i]) changed = true
            this.pluginConfig[i] = o[i]
          } else if (i === 'reset') {
            const conf = {
              ae: 1,
              visa: 1,
              mc: 1,
              paypal: 1,
              dis: 1,
              paypal2: 0,
              buttonText: this.$i18n.t('designTab.buttonPayDefaultText'),
              wixColor: 1,
              buttonClass: 'default',
              fontFamily: 'Montserrat',
              fontSize: '16',
              textColor: '#384766',
              mainColor: '#ffc43a',
              mainColor2: '#fbbb03',
              borderColor: '#b58c00',
              shadowColor: '#00000080',
              borderSize: 1,
              borderRound: 16
            }

            for (let i in conf) if (this.pluginConfig[i] !== undefined) this.pluginConfig[i] = conf[i]
            localStorage.setItem(`btn__reset_${this.getInstanceId()}`, true)
            changed = true
          }
        }

        localStorage.setItem(`vc_design_cfg_${this.getInstanceId()}`, JSON.stringify(this.pluginConfig))
        if (changed) this.apiUpdateDesignConfig(this.pluginConfig)
      }
    },
    updatePayments: function (o) {
      if (typeof o === 'object' && o !== null) {
        let changed = false

        for (let i in o) {
          let val = o[i]
          changed = this.paymConfig[i] !== val
          this.paymConfig[i] = val
        }

        localStorage.setItem(`vc_paym_cfg_${this.getInstanceId()}`, JSON.stringify(this.paymConfig))

        if (changed) {
          if (o.paypal_email !== undefined) {
            // this.apiUpdateDesignConfig({ showConnectedMsg: 0, showNonConnectedMsg: 0 })
            // this.pluginConfig.showNonConnectedMsg = 0
            if (o.paypal_email === '') this.pluginConfig.showConnectedMsg = 0
          }

          this.apiUpdatePaymentConfig(this.paymConfig)
        }
      }
    },
    apiGetAuthClientId: function () {
      const url = `${this.apiURL}/vcita_info`
      const _this = this

      axios
        .get(url)
        .then(function (response) {
          localStorage.setItem(`vcita_cid_${_this.getInstanceId()}`, response.data)
        })
        .catch(function (error) { console.log(error) })
    },
    apiGetClientData: function () {
      this.fetchingClientData = true
      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`client data not fetched, wrong instanceId ${instanceId}`)
        return
      }

      const _this = this
      const url = `${this.apiURL}/vcita_client_info/${instanceId}`

      axios
        .get(url)
        .then(function (response) {
          const d = Helpers.parseJSON(response.data)
          if (_this.$TEST_MODE) console.log(d)

          if (d !== null) {
            _this.pivot_id = d.pivot_id
            const cd = Helpers.parseJSON(d.client_data)
            if (_this.$TEST_MODE) console.log(cd)

            if (cd !== null) {
              _this.loggedIn = 1
              _this.userData = cd
              window.userData = cd
              localStorage.setItem(`vc_usr_data_${instanceId}`, JSON.stringify(cd))
              _this.syncPaymentConfig()
              _this.syncPlanData()
            } else _this.premiumFlag = false

            const dd = Helpers.parseJSON(d.design_conf)
            if (_this.$TEST_MODE) console.log(dd)

            if (dd !== null) {
              for (let i in dd) if (_this.pluginConfig[i] !== undefined) _this.pluginConfig[i] = dd[i]
              localStorage.setItem(`vc_design_cfg_${instanceId}`, JSON.stringify(_this.pluginConfig))
              for (let i in dd) if (_this.paymConfig[i] !== undefined) _this.paymConfig[i] = dd[i]
              localStorage.setItem(`vc_paym_cfg_${instanceId}`, JSON.stringify(_this.paymConfig))
            } else localStorage.setItem(`vc_design_cfg_${instanceId}`, JSON.stringify(_this.pluginConfig))

            if (_this.loggedIn && _this.firstLoad) {
              _this.currentTabName = 'Design'
              _this.changeTab(2)
            }
          } else {
            localStorage.removeItem(`vc_design_cfg_${instanceId}`)
            localStorage.removeItem(`vc_paym_cfg_${instanceId}`)
          }

          _this.fetchingClientData = false
        })
        .catch(function (error) { console.log(error) })
    },
    apiUpdateDesignConfig: function (config) {
      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`config not updated, wrong instanceId ${instanceId}`)
        return
      }

      const url = `${this.apiURL}/update_design_cfg/${instanceId}`

      axios.post(url, { config: config })
        .then(function (response) { console.log(response.data) })
        .catch(function (error) { console.log(error) })
    },
    apiUpdatePaymentConfig: function (config) {
      const instanceId = this.getInstanceId()

      if (instanceId === null) {
        console.error(`config not updated, wrong instanceId ${instanceId}`)
        return
      }

      const url = `${this.apiURL}/update_payment_cfg/${instanceId}`

      axios.post(url, { config: config })
        .then(function (response) { console.log(response.data) })
        .catch(function (error) { console.log(error) })
    },
    openUpgradePage: function () {
      Wix.Settings.openModal(`https://www.${this.$vcitaAddress}/account/upgrade?o=mail&confirmation_token=mRC6F5donB79kGr8ModW`, '100%', '100%', 'Upgrade your vCita account') // eslint-disable-line
    },
    nonSettingsTabMounted: function () {
      this.gatewayConnected = false
      this.alertAvailable = true

      /*
      if (this.pluginConfig.showConnectedMsg) {
       this.pluginConfig.showConnectedMsg = 0
       this.apiUpdateDesignConfig({ showConnectedMsg: 0 })
      }

      if (this.alertAvailable && this.pluginConfig.showNonConnectedMsg) {
        this.addNotice()
      }
      */
    },
    premiumTabMounted: function () {
      this.currentTabName = 'Premium'
    }
  },
  addNotice: function () {
    const el = document.querySelector('.vue-tablist > li')

    if (el !== null && el.querySelector('.alert-notice') === null) {
      el.insertAdjacentHTML('beforeend', '<i class="alert-notice">!</i>')
    }
  },
  removeNotice: function () {
    const el = document.querySelector('.vue-tablist > li')
    if (el !== null && el.querySelector('.alert-notice') !== null) el.removeChild(el.querySelector('.alert-notice'))
  },
  created: function () {
    window._instanceId = this.getInstanceId()
    this.fetchingClientData = true
    localStorage.removeItem('vc_usr_data_' + this.getInstanceId())
    this.apiGetClientData()
    this.apiGetAuthClientId()
  },
  mounted: function () {
    const _this = this

    const pr = function () {
      if (_this.firstLoad) {
        GA.track('wixpay_open_settings', { uid: _this.loggedIn ? _this.userData.business_id : null })
      }

      if (_this.firstLoad) _this.firstLoad = false

      window.setTimeout(function () {
        if (!_this.preloaderDeleted) {
          const form = document.querySelector('.with-preloader')
          if (form !== null) form.classList.remove('with-preloader')
          _this.preloaderDeleted = true
        }
      }, 200)
    }

    if (!this.fetchingClientData) {
      pr()
    } else {
      const int = window.setInterval(function () {
        if (!_this.fetchingClientData) {
          clearInterval(int)
          pr()
        }
      }, 200)
    }

    GA.init()

    let inter2 = setTimeout(function () {
      const mixpanel = window.mixpanel

      if (typeof mixpanel !== 'undefined') {
        clearInterval(inter2)
        mixpanel.init(_this.$mixpanelToken)

        if (typeof mixpanel.register === 'function') {
          mixpanel.register({
            'plugin': 'Integrations::WixPaymentsInstance',
            'wix_instance_id': _this.getInstanceId()
          })
        }
      }
    }, 100)

    const tabs = document.querySelectorAll('.vue-tablist > .vue-tab')
    const l1 = tabs.length

    for (let i = 0; i < l1; i++) {
      tabs[i].addEventListener('click', function () {
        if (_this.currentTabName === this.textContent) return false

        GA.track('wixpay_change_tab', {
          uid: _this.loggedIn ? _this.userData.business_id : null,
          page: _this.currentTabName,
          new_tab: this.textContent
        })

        _this.currentTabName = this.textContent
      })
    }

    if (!this.$TEST_MODE) {
      (function(h,o,t,j,a,r){ // eslint-disable-line
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; // eslint-disable-line
        h._hjSettings={hjid:1626934,hjsv:6}; // eslint-disable-line
        a=o.getElementsByTagName('head')[0]; // eslint-disable-line
        r=o.createElement('script');r.async=1; // eslint-disable-line
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; // eslint-disable-line
        a.appendChild(r); // eslint-disable-line
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv='); // eslint-disable-line
    } else {
      (function(h,o,t,j,a,r){ // eslint-disable-line
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; // eslint-disable-line
        h._hjSettings={hjid:1626934,hjsv:6}; // eslint-disable-line
        a=o.getElementsByTagName('head')[0]; // eslint-disable-line
        r=o.createElement('script');r.async=1; // eslint-disable-line
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; // eslint-disable-line
        a.appendChild(r); // eslint-disable-line
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv='); // eslint-disable-line
    }

    // this.pluginConfig.showSettingsLabel = 0
    // this.apiUpdateDesignConfig({ showSettingsLabel: 0 })
  }
}
</script>

<style lang="scss">
@import "../assets/style/_global.scss";
</style>
